var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.812012 27.7628C0.812012 12.5004 13.1846 0.127808 28.447 0.127808C43.7094 0.127808 56.0821 12.5004 56.0821 27.7628C56.0821 43.0252 43.7094 55.3979 28.447 55.3979C13.1846 55.3979 0.812012 43.0252 0.812012 27.7628Z",
    fill: "#242223",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3218 40.6378L38.5718 28.2628L18.3218 15.8878V40.6378ZM16.6343 13.005C17.689 12.3722 19.0249 12.3722 20.0796 13.005L40.3296 25.38C41.314 26.0128 41.9468 27.1378 41.9468 28.2628C41.9468 29.4581 41.314 30.5831 40.3296 31.1456L20.0796 43.5206C19.0249 44.2238 17.689 44.2238 16.6343 43.5909C15.5796 43.0284 14.9468 41.9034 14.9468 40.6378V15.8878C14.9468 14.6925 15.5796 13.5675 16.6343 13.005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play-btn.ea9d4b0d7db0d22a6c950cf092d7d5b0.svg";
export { ForwardRef as ReactComponent };